(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  if(typeof LunaMarqueeSwiper !== 'function') {
    class LunaMarqueeSwiper extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.swiper');
        this.settings = {
          speed: parseInt(this.dataset.speed),
          autoplay: {
            disableOnInteraction: false,
            delay: 100
          },
          on: {
            init: () => {
              this.querySelector('.swiper-wrapper').style.opacity = 1;
            },
          },
          centeredSlides: true,
          freeMode: true,
          loop: true,
          loopedSlides: Math.max(parseInt(this.dataset.mobile), parseInt(this.dataset.size)),
          slidesPerView: parseInt(this.dataset.mobile),
          spaceBetween: parseInt(this.dataset.spaceBetween),
          breakpoints: {
            750: {
              loopedSlides: Math.max(parseInt(this.dataset.tablet), parseInt(this.dataset.size)),
              slidesPerView: parseInt(this.dataset.tablet)
            },
            1250: {
              loopedSlides: Math.max(parseInt(this.dataset.desc), parseInt(this.dataset.size)),
              slidesPerView: parseInt(this.dataset.desc)
            },
            1800: {
              loopedSlides: Math.max(parseInt(this.dataset.desc) + 2, parseInt(this.dataset.size)),
              slidesPerView: parseInt(this.dataset.desc) + 2
            }
          }
        };
        this.swipper;

        this.init();
        document.addEventListener("shopify:section:load", (event) => {
          this.appendAssets();
          this.init();
        });

        window.addEventListener('resize', () => {
          setTimeout(() => {
            this.swipper.update();
            this.swipper.slideToLoop(this.swipper.realIndex, 0);
          }, 300);
        })
      }
      appendAssets() {
        const link = document.createElement('link');
        const script = document.createElement('script');

        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';

        document.head.appendChild(link);
        document.body.appendChild(script);
      }
      init() {
        if (typeof Swiper !== 'function') {
          this.appendAssets();
          this.swiperChecker();
        } else {
          this.initSlider();
        }
      }
      initSlider() {
        if (this.swipper && this.swipper.destroy) {
          this.swipper.destroy();
          this.swipper = null;

          this.swipper = new Swiper(this.slider, this.settings);
        } else {
          this.swipper = new Swiper(this.slider, this.settings);
        }
      }
      swiperChecker() {
        const interval = setInterval(() => {
          if (typeof Swiper !== 'function') {
            this.swiperChecker();
          } else {
            clearInterval(interval);
            this.initSlider();
          }
        }, 100);
      }
    }
    customElements.define('luna-marquee-swiper', LunaMarqueeSwiper);
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-product-footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      );
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticker2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-animated')) {
    class StickerAnimated extends HTMLElement {
      constructor() {
        super()
        this.animationSpeed = parseFloat(this.dataset.animationSpeed)

        this.init()

        document.addEventListener('readystatechange', function() {
          if(document.readyState == 'interactive') {
          }
        })
        document.addEventListener("shopify:section:load", (event) => {
          this.init()
        });
      }
      init() {
        this.selecter = ".stckrimg"
        this.stckrimgs = this.querySelectorAll(this.selecter);
        this.scroll();
      }
      scroll() {
        Array.from(this.stckrimgs).forEach(stckrimg => {
          window.addEventListener("scroll", () => {
            const section = stckrimg.closest(`.shopify-section`)
            const LT__section = stckrimg.closest(`.luna-templates__animated-sticker`)
            const sticker = this.querySelector('.luna-templates-animated-sticker');
            const {bottom, top} = sticker.getBoundingClientRect();

            if (top > 0 && (bottom - window.innerHeight) < 0) {
              if (LT__section.dataset.animation == "spin-scroll") {
                stckrimg.style.rotate = (bottom * this.animationSpeed) + "deg";
                stckrimg.style.top = 0 + "px";
              }

              if (LT__section.dataset.animation == "float-scroll") {
                stckrimg.style.rotate = 0 + "deg";
                // stckrimg.style.top = ((bottom + (window.innerHeight / 2)) * this.animationSpeed) + "px";
                stckrimg.style.top = (((sticker.offsetTop + this.offsetTop) - (window.scrollY + (window.innerHeight / 2))) * this.animationSpeed) + "px";
              }
            }
          }, {
            passive: true,
            capture: false,
          })
        })
      }
    }
    customElements.define('sticker-animated', StickerAnimated)
  }

  } catch(e) { console.error(e); }
})();
})();
